import React, { useState, useRef, useEffect } from 'react'
import styles from "./Environmentpanel.module.css"
import CustomModal from './Modal';
import { useNavigate } from 'react-router-dom';
import { logout_Api, create_environment_Api, create_environment_file_Api, get_all_environment_Api, current_user_Api } from '../../dashboardapi';
import Environmentfiles from './Environmentfiles';
import data from "../../json/Config.json"
import { useToast } from '@chakra-ui/react';

const Environmentpanel = () => {

    const [showmodal, setShowModal] = useState(false);
    const [environmentTitle, setEnvironmentTitle] = useState("")
    const fileInputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [show, setShow] = useState(false);
    const [inputFiles, setInputFiles] = useState([]);
    const [environments, setEnvironments] = useState();
    const [showDetails, setShowDetails] = useState({ show: false, env: "", id: "" })
    const [userdetail, setUserDetail] = useState("")
    const ref = useRef();

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target) && !event.target.closest(".togglebtn")) {
            setShow(false)
        }
    };

    const handledropdown = () => {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {
        let details = async () => {
            try {
                let result = await current_user_Api();
                if (result.data) {
                    setUserDetail(result.data.message)
                }
            } catch (error) {
                console.log(error);
            }
        }

        details();

        document.addEventListener('mousedown', handleClickOutside);
        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    const navigate = useNavigate();

    const toast = useToast();

    useEffect(() => {
        fetchEnvironemnt()
    }, [])

    const fetchEnvironemnt = async () => {
        let result = await get_all_environment_Api();
        if (result.data) {
            setEnvironments(result.data)
        } else {
            const error = result.error.Message || "An error Occured";
            toast({
                title: "Problem getting Templates",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }


    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        handleFiles(files); // Handle dropped files
    };

    const handleFiles = (files) => {
        let size = 3000;
        let allowedfiles = [];
        let count = 0;
        const fileslist = Array.from(files)
        for (let n of fileslist) {
            count += (n.size * 0.001)
            if (count < size) {
                allowedfiles.push(n)
                console.log(count);
            }
        }
        if (fileslist.length !== allowedfiles.length) {
            toast({
                title: "Total Files size should be less than 3mb",
                description: "",
                duration: "2000",
                status: "warning",
                isClosable: "true"
            })
        }
        // setInputFiles((prev) => [...prev, ...fileslist])
        setInputFiles(allowedfiles)
    };

    const handleClick = () => {
        fileInputRef.current.click(); // Trigger file input click
    };

    const handleChange = (e) => {
        setEnvironmentTitle(e.target.value)
    }

    const createFile = async (e) => {
        e.preventDefault();

        let result = await create_environment_Api(environmentTitle)
        if (result.data) {
            setShowModal(false)
            toast({
                title: "Environment created successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            if (inputFiles.length > 0) {
                let file = await create_environment_file_Api(result.data.uuid, inputFiles)
                if (file.data) {
                    setShowModal(false)
                    toast({
                        title: "Files uploaded successfully",
                        description: "",
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                } else {
                    const errorMessage = file.error.message || "An error occurred"
                    toast({
                        title: "Problem uploading files ",
                        description: errorMessage,
                        status: "error",
                        duration: 2000,
                        isClosable: "true"
                    })
                    setInputFiles([])
                }
                fetchEnvironemnt()
            } else {
                setShowModal(false)
                fetchEnvironemnt()
            }
        } else {
            const errorMessage = result.error.message || "An error occurred.";
            toast({
                title: "Problem getting files",
                description: errorMessage,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleSignOut = async (e) => {
        let response = await logout_Api();
        if (response.data) {
            localStorage.removeItem("token")
            navigate("/loginnew/signIn")
            toast({
                title: "Signed Out Successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
        } else {
            toast({
                title: "Problem signing out",
                description: "Please try again later",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleDelete = (todelete) => {
        setInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const showEnvDetails = (env, i) => {
        setShowDetails({ show: true, env: env, id: i })
    }

    return (
        <div className={styles.environment_outer}>
            <CustomModal show={showmodal}>
                <div className={styles.modalouter}>
                    <div style={{ padding: '24px', borderRight: '0.6px solid #CCCBD3', width: '50%' }}>
                        <div className={styles.modalheader}>
                            New {data.environmenttitle}
                        </div>
                        <form className={styles.formouter} method='POST' onSubmit={createFile}>
                            <div className={styles.inputname}>
                                <label>{data.environmenttitle} Title<span style={{
                                    color: "red", fontWeight: '600'
                                }}>*</span></label>
                                <input type='text' name='environment_name' onChange={handleChange} maxLength={50} placeholder='Enter Environment Name' required />
                            </div>
                            <div className={`${styles.inputdiv} ${dragging ? styles.dragging : ''}`} onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}>
                                {dragging ? (
                                    // When dragging, show this content
                                    <div style={{ height: '133px' }}>
                                        Drag your file here
                                    </div>
                                ) : (
                                    <>
                                        <p>
                                            <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"} alt='' />
                                        </p>
                                        <div>Upload your files</div>
                                        <p>Drag and drop your files here or <a onClick={handleClick} >choose files</a></p>
                                        <input
                                            type='file'
                                            name='project_name'
                                            placeholder='Enter Project Name'
                                            ref={fileInputRef}
                                            style={{ display: 'none' }} // hide the file input
                                            multiple
                                            onChange={(e) => handleFiles(e.target.files)}
                                        />
                                    </>
                                )}
                            </div>

                            <div className={styles.actionbtn}>
                                <button className={styles.btn1} onClick={() => (setShowModal(false), setInputFiles([]))}>Cancel</button>
                                <button className={styles.btn2} type='submit'>Create</button>
                            </div>
                        </form>
                    </div>

                    <div style={{ paddingBottom: '24px', width: '50%' }}>
                        <div className={styles.modalheader} style={{ padding: '24px 24px 18px 24px', borderBottom: '0.6px solid #CCCBD3' }}>
                            Uploaded {data.environmenttitle}
                        </div>
                        <div className={`${styles.envi_list} ${styles.scrollable}`} style={{ marginTop: '24px' }}>
                            {inputFiles ? inputFiles.map((file, id) => (
                                <div key={id}>
                                    <span>
                                        <p>{file.name}</p>
                                        <p style={{ fontSize: '0.75rem', color: '#5C5B60' }}>{file.type} I {file.size < 1000000 ? (file.size / 1024).toFixed(2) : file.size} {file.size < 1000000 ? "kb" : "mb"} </p>
                                    </span>
                                    <button onClick={() => handleDelete(file.name)}>
                                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='' />
                                    </button>
                                </div>
                            )) : ""}
                        </div>
                    </div>
                </div>
            </CustomModal >

            <div className={styles.environment_header}>
                <div className={styles.notification}>
                    <button>
                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/bellicon.svg"} alt='notification_icon' />
                    </button>
                    <button>
                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/helpicon.svg"} alt='Help_icon' />
                    </button>
                </div>
                <div className={`${styles.profile_section} togglebtn`} onClick={handledropdown}>
                    <div className={styles.profile_pic}>
                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/profilepic.png"} alt='profile_pic' style={{ height: "auto", width: "auto" }} />
                    </div>
                    <button>
                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/arrowhead.svg"} alt='toogle_btn' style={{
                            transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s ease', // Smooth rotation
                        }} />
                    </button>
                    {
                        show && <div ref={ref} className={styles.settingmodal}>
                            <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "20px" }}>
                                <h1>{userdetail}</h1>
                                <button onClick={handleSignOut}>Sign Out</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className={styles.environmentcreation_section}>
                <div>
                    <h1 className={styles.environment_title}>{data.environmenttitle}</h1>
                </div>
                <button className={`${styles.environment_buttons} ${styles.envbtn1}`} onClick={() => (setShowModal(true), setInputFiles([]))}>
                    <span>
                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/envfilesicon.png"} alt='icon' />
                    </span>
                    <span className={styles.line1}></span>
                    <p>Create Your Own</p>
                </button>
                <button className={`${styles.environment_buttons} ${styles.envbtn2}`}>
                    <span>
                        <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/templatescon.png"} alt='icon' />
                    </span>
                    <span className={styles.line2}></span>
                    <p>Browse Templates</p>
                </button>
            </div>
            <div className={styles.environment_display}>
                <h1 className={styles.envlisttitle}>Added {data.environmenttitle}</h1>
                <div className={styles.envlist_outer}>
                    {environments ? environments.map((env, i) => (

                        <button onClick={() => showEnvDetails(env, i)} key={i} className={styles.envlist}>
                            {env.is_readonly ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-lock" viewBox="0 0 16 16">
                                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
                            </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-unlock" viewBox="0 0 16 16">
                                <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2M3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z" />
                            </svg>}
                            <p>&nbsp;&nbsp;{env.name}</p>
                        </button>
                    )) : ""}
                </div>
            </div>
            {showDetails.show && <Environmentfiles showModal={showDetails.show} index={showDetails.id} file={showDetails.env} setshowdetails={setShowDetails} fetchenvi={fetchEnvironemnt} />}
        </div >
    )
}

export default Environmentpanel